module.exports = "pegasus/assets/circle-google.gif";